// Lib
import { mapValues, round, ceil } from 'lodash/fp';

export const roundVals = mapValues(round);
export const roundUpVals = mapValues(ceil);
